import React from 'react';
import { motion } from 'framer-motion';
import { X, Mail } from 'lucide-react';
import PopupTransition from '@/components/ui/PopupTransition';

interface InviteTeamMemberModalProps {
  open: boolean;
  onClose: () => void;
}

const InviteTeamMemberModal: React.FC<InviteTeamMemberModalProps> = React.memo(({ open, onClose }) => {
  return (
    <PopupTransition open={open} setOpen={onClose}>
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl">
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Πρόσκληση Μέλους Ομάδας</h2>
            <p className="text-sm text-gray-600">Στείλτε μία πρόσκληση για συμμετοχή στην ενεργειακή σας ομάδα</p>
          </div>
          <button
            onClick={onClose}
            className="rounded-lg p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Form */}
        <div className="space-y-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">Πλήρες Όνομα</label>
            <input
              type="text"
              placeholder="Εισάγετε το πλήρες όνομα"
              className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">Διεύθυνση Email</label>
            <input
              type="email"
              placeholder="Εισάγετε τη διεύθυνση email"
              className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">Ρόλος</label>
            <select className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none">
              <option value="">Επιλέξτε ρόλο</option>
              <option value="energy-engineer">Ενεργειακός Μηχανικός</option>
              <option value="project-manager">Διευθυντής Έργου</option>
              <option value="solar-technician">Τεχνικός Φωτοβολταϊκών</option>
              <option value="data-analyst">Αναλυτής Δεδομένων</option>
              <option value="safety-inspector">Επιθεωρητής Ασφάλειας</option>
              <option value="maintenance-lead">Υπεύθυνος Συντήρησης</option>
            </select>
          </div>

          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">Τμήμα</label>
            <select className="w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-gray-900 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none">
              <option value="">Επιλέξτε τμήμα</option>
              <option value="engineering">Μηχανική</option>
              <option value="operations">Λειτουργίες</option>
              <option value="field-operations">Επιχειρήσεις Πεδίου</option>
              <option value="analytics">Ανάλυση Δεδομένων</option>
              <option value="safety-compliance">Ασφάλεια & Συμμόρφωση</option>
              <option value="maintenance">Συντήρηση</option>
            </select>
          </div>

          <div className="rounded-xl border border-blue-200 bg-blue-50 p-4">
            <div className="flex items-start gap-3">
              <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
                <Mail className="h-3 w-3 text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-blue-900">Λεπτομέρειες Πρόσκλησης</p>
                <p className="mt-1 text-xs text-blue-700">
                  Θα σταλεί email πρόσκλησης με οδηγίες ρύθμισης και προσωρινά διαπιστευτήρια πρόσβασης.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="mt-8 flex gap-3">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onClose}
            className="flex-1 rounded-xl border border-gray-200 bg-white px-4 py-3 text-gray-700 hover:bg-gray-50"
          >
            Ακύρωση
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex-1 rounded-xl bg-blue-600 px-4 py-3 text-white hover:bg-blue-700"
          >
            Αποστολή Πρόσκλησης
          </motion.button>
        </div>
      </div>
    </PopupTransition>
  );
});

InviteTeamMemberModal.displayName = 'InviteTeamMemberModal';

export default InviteTeamMemberModal;
